import { useEffect } from "react";
import useCategory from "./useCategory";
import { useSearchParams } from "react-router-dom";
import styles from "./CategoryBar.module.css";
import Cat from "./Cat";
import FilterSort from "./FilterSort/FilterSort";
import { useSelector } from "react-redux";
export default function CategoryBar({ filter = false }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { categories, loading, fetchCategories } = useCategory();
  const slugList = searchParams.get("cat")?.split(",") || [];
  const depth = 0;

  const { channel } = useSelector((state) => state.Login);

  useEffect(() => {
    if (categories.length) {
      if (!searchParams.get("cat")) {
        let activeCategory = categories.find(
          (cat) => cat.sub_categories.length > 0,
        );

        setSearchParams(
          (prev) => {
            prev.set("cat", activeCategory?.id);
            return prev;
          },
          { replace: true },
        );
      }
    }
  }, [categories.length, setSearchParams]);

  useEffect(() => {
    fetchCategories();
  }, [channel]);
  return (
    <div className={`full-width ${styles.CategoryBarContainer}`}>
      <Cat categories={categories} depth={depth} loading={loading} />
      {filter && (
        <FilterSort
          category_id={slugList[slugList.length - 1]}
          level={0}
          fetchCategories={() => {}}
        />
      )}
    </div>
  );
}
